import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Box, Typography, TextField, IconButton, Stack, Alert, CircularProgress } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PasswordModal = ({ open, onClose, onSubmit, errorMessage, isLoading }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleShowPasswordToggle = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = () => {
    onSubmit(password);
    setPassword('');
  };

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      disableEscapeKeyDown={true}
      aria-labelledby="password-modal-title"
      sx={{
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: '50%' },
          height: 'auto',
          bgcolor: 'var(--base-color)',
          boxShadow: 24,
          p: 5,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2} sx={{ fontFamily: 'Inerta, sans-serif', color:'var(--inverse-color)' }}>
          {t('password_modal.title')}
        </Typography>

        <Stack
          direction="column"
          spacing={2}
          alignItems="center"
        >
          <TextField
            label={t('password_modal.placeholder')}
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            value={password}
            onChange={handlePasswordChange}
            fullWidth
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={handleShowPasswordToggle}
                  edge="end"
                  sx={{ padding: '10px' }}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <button
            className="button primary-button"
            variant="contained"
            onClick={handleSubmit}
            disabled={!password || isLoading}
            sx={{ width: 'fit-content' }}
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : t('password_modal.submit')}
          </button>
        </Stack>

        {errorMessage && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMessage}
          </Alert>
        )}
      </Box>
    </Modal>
  );
};

export default PasswordModal;
